module.exports = __webpack_public_path__ + "img/vegetable-leeks-190x100.6a84d952.jpg";